import SettingsInvoicesModule from './settings-invoices.module'

export default SettingsInvoicesModule
